import moment from "moment";
import $ from "jquery";
import { toast } from "react-custom-alert";
import "react-custom-alert/dist/index.css";

///--------------------------saraserviciosmultiples-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://saraserviciosmultiples.mtechnologypanama.com"; // SERVIDOR
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/saraserviciosmultiples"; // SERVIDOR DE IAMAGENES
///--------------------------saraserviciosmultiples-------------------------------///

///--------------------------maderascocheran-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://maderascocheran.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/maderascocheran"; // SERVIDOR DE IAMAGENES
///--------------------------maderascocheran-------------------------------///
///--------------------------TANIA-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=true;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=true;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="http://192.168.100.25:8080"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="C:/xampp/htdocs/"; // SERVIDOR DE IMAGENES
///--------------------------TANIA-------------------------------///
///--------------------------remate-------------------------------///
// export const VERSION_1 = false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE = true;

// export const RECIBO_NAME = "RECIBO";
// export const RECIBO_ENABLED = true;
// export const LOGO_COTIZACION_2_ENABLE = false;
// export const LOGO_COTIZACION_3_ENABLE = false;
// export const IP ="http://192.168.10.105:8080"; //REMATE DE LAS OFERTAS
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "C:/xampp/htdocs/"; // SERVIDOR DE IMAGENES
///--------------------------remate-------------------------------///
///--------------------------mtechnologypanama-------------------------------///
// export const IP = "https://mtc.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export const IP_FE_COMANDA = "https://livable-unsent-proposal.ngrok-free.dev"; //IP CONSULTAS DE FE
// export const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/mtc"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///
///--------------------------miradorgualaca-------------------------------///
// export const IP = "https://miradorgualaca.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "https://identical-guidance-specked.ngrok-free.dev"; //IP CONSULTAS DE FE
// export const IP_FE_COMANDA = "https://identical-guidance-specked.ngrok-free.dev"; //IP CONSULTAS DE FE
// export const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/miradorgualaca"; // SERVIDOR DE IMAGENES
///--------------------------miradorgualaca-------------------------------///
///--------------------------mtechnologypanama-------------------------------///
// export const IP = "https://pmpsa.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/pmpsa"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///

///--------------------------mtechnologypanama-------------------------------///
// export const IP = "https://miamiavenue.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/miamiavenue"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///
///--------------------------ORLANDO SANCHEZ-------------------------------///
// export const IP = "https://orlandosanchez.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/orlandosanchez"; // SERVIDOR DE IMAGENES
///--------------------------ORLANDO SANCHEZ-------------------------------///
///--------------------------ORLANDO SANCHEZ-------------------------------///
// export const IP = "https://glen.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/glen"; // SERVIDOR DE IMAGENES
///--------------------------ORLANDO SANCHEZ-------------------------------///
///--------------------------franklinrojas-------------------------------///
// export const IP = "https://franklinrojas.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/franklinrojas"; // SERVIDOR DE IMAGENES
///--------------------------franklinrojas-------------------------------///
///--------------------------servicios y restaurantes NG-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://serviciosyrestaurantesng.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/serviciosyrestaurantesng"; // SERVIDOR DE IMAGENES
///--------------------------servicios y restaurantes NG-------------------------------///
// ///--------------------------centrodebaterias ISLA-------------------------------///
// export const IP ="https://sistema.centrodebaterias.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export const IP_FE_COMANDA = "https://livable-unsent-proposal.ngrok-free.dev"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/centrodebaterias.com/public_html/sistema"; //NUBE BATERIA
///--------------------------centrodebaterias ISLA-------------------------------///
///--------------------------centrodebaterias CHANGUINOLA-------------------------------///
// export const IP ="https://changuinola.centrodebaterias.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/centrodebaterias.com/public_html/changuinola"; //NUBE BATERIA
///--------------------------centrodebaterias CHANGUINOLA-------------------------------///
///--------------------------baustrandsa-------------------------------///
// export const IP ="https://baustrandsa.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/baustrandsa"; //NUBE BATERIA
///--------------------------baustrandsa-------------------------------///
///--------------------------serviciosyrestaurantesng-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://serviciosyrestaurantesng.mtechnologypanama.com"; // SERVIDOR
// // export const IP_FE_CONSULTAS ="https://serviciosyrestaurantesng.mtechnologypanama.com"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/serviciosyrestaurantesng"; // SERVIDOR DE IMAGENES
///--------------------------mtechnologypanama-------------------------------///

///--------------------------fiestasinfantiles-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://fiestasinfantiles.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// // export const IP_FE_CONSULTAS ="https://fiestasinfantiles.mtechnologypanama.com"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/fiestasinfantiles"; // SERVIDOR DE IMAGENES
///--------------------------fiestasinfantiles-------------------------------///
///--------------------------fundacion_los_naturalistas-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://naturalistas.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/naturalistas"; // SERVIDOR DE IMAGENES
///--------------------------fundacion_los_naturalistas-------------------------------///
///--------------------------fundacion_los_naturalistas-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://cdbbgaba.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/cdbbgaba"; // SERVIDOR DE IMAGENES
///--------------------------fundacion_los_naturalistas-------------------------------///
///--------------------------Transmisiones valencia-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://transmisionesvalencia.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/transmisionesvalencia"; // SERVIDOR DE IMAGENES
///--------------------------Transmisiones valencia-------------------------------///
///--------------------------ART_MODUL-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://artmodul.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/artmodul"; // SERVIDOR DE IMAGENES
///--------------------------ART_MODUL-------------------------------///
///--------------------------MARIANA MACHADO-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://marianamachado.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/marianamachado"; // SERVIDOR DE IMAGENES
///--------------------------MARIANA MACHADO-------------------------------///
///--------------------------GRUPPO AZZAM-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://grupoazzamsa.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/grupoazzamsa"; // SERVIDOR DE IMAGENES
///--------------------------GRUPPO AZZAM-------------------------------///
///--------------------------LAVANDERIA TOMMY-------------------------------///
export const IP = "https://lavanderiatommy.mtechnologypanama.com"; // SERVIDOR
export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
export const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/lavanderiatommy"; // SERVIDOR DE IMAGENES
export const IP_FE_COMANDA = ""; //IP CONSULTAS DE FE
///--------------------------LAVANDERIA TOMMY-------------------------------///
///--------------------------CRISTHIAN CHAVARRIA-------------------------------///
// export const IP ="https://cristhianchavarria.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/cristhianchavarria"; // SERVIDOR DE IMAGENES
///--------------------------CRISTHIAN CHAVARRIA-------------------------------///
///--------------------------DISTRIBUIDORA ROUXSAC-------------------------------///
// export const IP ="https://rouxsac.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/rouxsac"; // SERVIDOR DE IMAGENES
///--------------------------DISTRIBUIDORA ROUXSAC-------------------------------///
///--------------------------PASCUAL MORALES MORALES-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://pascualmorales.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/pascualmorales"; // SERVIDOR DE IMAGENES
///--------------------------PASCUAL MORALES MORALES-------------------------------///
///--------------------------TRASPORTE BRAYAN BEITIA-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://trasportebrayanbeitia.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/trasportebrayanbeitia"; // SERVIDOR DE IMAGENES
///--------------------------TRASPORTE BRAYAN BEITIA-------------------------------///
///--------------------------ABTELECOM-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=true;
// export const IP ="https://abtelecom.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/abtelecom"; // SERVIDOR DE IMAGENES
///--------------------------ABTELECOM-------------------------------///
///--------------------------constructorakrcc-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://constructorakrcc.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/constructorakrcc"; // SERVIDOR DE IMAGENES
///--------------------------constructorakrcc-------------------------------///
///--------------------------andresquintero-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://andresquintero.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/andresquintero"; // SERVIDOR DE IMAGENES
///--------------------------andresquintero-------------------------------///
///--------------------------MULTISERVICIOS GALPAS-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://multiserviciosgalpas.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/multiserviciosgalpas"; // SERVIDOR DE IMAGENES
///--------------------------MULTISERVICIOS GALPAS-------------------------------///
///--------------------------MULTISERVICIOS HALAM-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://multiserviciosyventashalam.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/multiserviciosyventashalam"; // SERVIDOR DE IMAGENES
///--------------------------MULTISERVICIOS HALAM-------------------------------///
///--------------------------PISABEL-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://pisabel.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/pisabel"; // SERVIDOR DE IMAGENES
///--------------------------PISABEL-------------------------------///
///--------------------------EBANISTERIA GONZALEZ JARAMILLO-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://ebanisteriagj.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/ebanisteriagj"; // SERVIDOR DE IMAGENES
///--------------------------MUEBLES & MAS-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://mueblesymas.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/mueblesymas"; // SERVIDOR DE IMAGENES
///--------------------------MUEBLES & MAS-------------------------------///
///--------------------------RT11-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://rt11.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/rt11"; // SERVIDOR DE IMAGENES
///--------------------------RT11-------------------------------///
///--------------------------tecnosuministrosjp-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://tecnosuministrosjp.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/tecnosuministrosjp"; // SERVIDOR DE IMAGENES
///--------------------------tecnosuministrosjp-------------------------------///
///--------------------------agricoladelatlantico-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://agricoladelatlantico.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/agricoladelatlantico"; // SERVIDOR DE IMAGENES
///--------------------------agricoladelatlantico-------------------------------///
///--------------------------panapluma-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://panapluma.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/panapluma"; // SERVIDOR DE IMAGENES
///--------------------------panapluma-------------------------------///
///--------------------------SERVIDORLOCAL-------------------------------///
// export const VERSION_1=false;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=true;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="http://localhost:8080"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/panapluma"; // SERVIDOR DE IMAGENES
///--------------------------SERVIDORLOCAL-------------------------------///
///--------------------------GRUPO JAWEL, S.A.-------------------------------///
// export const VERSION_1=true;//VERSION 1-> SOLO FACTURA MOBILE SIN INVENTARIO
// export const MODULO_RESTAURANTE=false;
// export const RECIBO_NAME="Cotización";
// export const RECIBO_ENABLED=false;
// export const LOGO_COTIZACION_2_ENABLE=false;
// export const LOGO_COTIZACION_3_ENABLE=false;
// export const IP ="https://grupojawels.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL ="http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES ="/home/u565547220/domains/mtechnologypanama.com/public_html/grupojawels"; // SERVIDOR DE IMAGENES
///--------------------------GRUPO JAWEL, S.A.-------------------------------///
///--------------------------constructoratejera-------------------------------///
// export const IP = "https://constructoratejera.mtechnologypanama.com"; // SERVIDOR
// export const IP_FE_LOCAL = "http://localhost:8080"; //IP CONSULTAS DE FE
// export  const IP_IMAGENES = "/home/u565547220/domains/mtechnologypanama.com/public_html/constructoratejera"; // SERVIDOR DE IMAGENES
///--------------------------constructoratejera-------------------------------///
// export const IP ="http://localhost:8080";
// export const IP ="http://192.168.100.25:8080"; // TANIA
// export const IP ="http://192.168.10.105:8080"; //REMATE DE LAS OFERTAS
// export const IP ="http://192.168.50.119:8080"; // BATERIA CHANGUINOLA
// export const IP ="https://sistema.centrodebaterias.com"; // SERVIDOR ONLINE BATERIA

// export  const IP_IMAGENES ="C:/nginx1.28/html"; //LOCAL
// export  const IP_IMAGENES ="C:/xampp/htdocs"; //LOCAL
// export  const IP_IMAGENES ="/home/u565547220/domains/centrodebaterias.com/public_html/sistema"; //NUBE BATERIA

export const url = IP + "/sys_mbo/";
export const urlFacturaElectronica = IP + "/sys_mbo/tax_sysm/";
export const imgURLServer = IP_IMAGENES + "/sys_mbo/uploads/articulos/";
export const imgURLServerGastos = IP_IMAGENES + "/sys_mbo/uploads/gastos/";
export const imgURLServerGastosPreview = IP + "/sys_mbo/uploads/gastos/";
export const imgURLServerPublicidad = IP_IMAGENES + "/sys_mbo/uploads/publicidad/";
export const imgURLLocalImageIp = IP + "/sys_mbo/uploads/publicidad/";
export const imgURLocalImage = IP + "/sys_mbo/uploads/articulos/";

export const isMobileOrTablet = window.innerWidth < 992;
export const nonce = "enc-base64";
export const path = "login";
export const privateKey = "MIICXAIBAAKBgQCqGKukO1De7zhZj6+H0qtjTkVxwTCpvKe4eCZ0FPqri0cb2JZfXJ";
export const CPBS = [
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1010", descripcion: "Animales vivos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1011", descripcion: "Productos para animales domésticos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1012", descripcion: "Comida de animales" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1013", descripcion: "Recipientes y hábitat para animales" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1014", descripcion: "Productos de talabartería y arreo" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1015", descripcion: "Semillas, bulbos, plántulas y esquejes" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1016", descripcion: "Productos de floricultura y silvicultura" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1017", descripcion: "Fertilizantes y nutrientes para plantas y herbicidas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1019", descripcion: "Productos para el control de plagas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1020", descripcion: "Rosales vivos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1021", descripcion: "Plantas vivas de especies o variedades de flores altas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1022", descripcion: "Plantas vivas de especies o variedades de flores bajas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1023", descripcion: "Crisantemos vivos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1024", descripcion: "Claveles vivos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1025", descripcion: "Orquídeas vivas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1030", descripcion: "Rosas frescas cortadas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1031", descripcion: "Bouquets cortados frescos de especies o variedades de flores altas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1032", descripcion: "Bouquets cortados frescos de especies o variedades de flores bajas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1033", descripcion: "Crisantemos cortados frescos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1034", descripcion: "Bouquets florales cortados frescos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1035", descripcion: "Claveles cortados frescos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1036", descripcion: "Orquídeas cortadas frescas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1040", descripcion: "Rosas cortadas secas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1041", descripcion: "Bouquets cortados secos de especies o variedades de flores altas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1042", descripcion: "Bouquets cortados secos de especies o variedades de flores bajas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1043", descripcion: "Crisantemos cortados secos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1044", descripcion: "Claveles cortados secos" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1045", descripcion: "Orquídeas cortadas secas" },
  { segmento: "10", segmentoDescripcion: "Material Vivo Vegetal y Animal, Accesorios y Suministros", codigo: "1050", descripcion: "Follaje cortado fresco" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1110", descripcion: "Minerales, minerales metálicos y metales" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1111", descripcion: "Tierra y piedra" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1112", descripcion: "Productos no comestibles de planta y silvicultura" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1113", descripcion: "Productos animales no comestibles" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1114", descripcion: "Chatarra y materiales de desecho" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1115", descripcion: "Fibra, hilos e hilados" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1116", descripcion: "Tejidos y materiales de cuero" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1117", descripcion: "Aleaciones" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1118", descripcion: "Óxido metálico" },
  { segmento: "11", segmentoDescripcion: "Material Mineral, Textil y Vegetal y Animal No Comestible", codigo: "1119", descripcion: "Desechos metálicos y chatarra" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1213", descripcion: "Materiales explosivos" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1214", descripcion: "Elementos y gases" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1216", descripcion: "Aditivos" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1217", descripcion: "Colorantes" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1218", descripcion: "Ceras y aceites" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1219", descripcion: "Solventes" },
  { segmento: "12", segmentoDescripcion: "Productos Químicos incluyendo Bioquímicos y Materiales de Gas", codigo: "1235", descripcion: "Compuestos y mezclas" },
  { segmento: "13", segmentoDescripcion: "Resina y Colofonia y Caucho y Espuma y Película y Materiales Elastoméricos", codigo: "1310", descripcion: "Caucho y elastómeros" },
  { segmento: "13", segmentoDescripcion: "Resina y Colofonia y Caucho y Espuma y Película y Materiales Elastoméricos", codigo: "1311", descripcion: "Resinas y colofonias y otros materiales derivados de resina" },
  { segmento: "14", segmentoDescripcion: "Materiales y Productos de Papel", codigo: "1400", descripcion: "Materiales y Productos de Papel" },
  { segmento: "14", segmentoDescripcion: "Materiales y Productos de Papel", codigo: "1410", descripcion: "Materiales de papel" },
  { segmento: "14", segmentoDescripcion: "Materiales y Productos de Papel", codigo: "1411", descripcion: "Productos de papel" },
  { segmento: "14", segmentoDescripcion: "Materiales y Productos de Papel", codigo: "1412", descripcion: "Papel para uso industrial" },
  { segmento: "15", segmentoDescripcion: "Combustibles, Aditivos para Combustibles, Lubricantes y Materiales Anticorrosivos", codigo: "1510", descripcion: "Combustibles" },
  { segmento: "15", segmentoDescripcion: "Combustibles, Aditivos para Combustibles, Lubricantes y Materiales Anticorrosivos", codigo: "1511", descripcion: "Combustibles gaseosos y aditivos" },
  { segmento: "15", segmentoDescripcion: "Combustibles, Aditivos para Combustibles, Lubricantes y Materiales Anticorrosivos", codigo: "1512", descripcion: "Lubricantes, aceites, grasas y anticorrosivos" },
  { segmento: "15", segmentoDescripcion: "Combustibles, Aditivos para Combustibles, Lubricantes y Materiales Anticorrosivos", codigo: "1513", descripcion: "Combustible para reactores nucleares" },
  { segmento: "20", segmentoDescripcion: "Maquinaria y Accesorios de Minería y Perforación de Pozos", codigo: "2010", descripcion: "Maquinaria y equipo de minería y explotación de canteras" },
  { segmento: "20", segmentoDescripcion: "Maquinaria y Accesorios de Minería y Perforación de Pozos", codigo: "2011", descripcion: "Equipo de perforación y explotación de pozos" },
  { segmento: "20", segmentoDescripcion: "Maquinaria y Accesorios de Minería y Perforación de Pozos", codigo: "2012", descripcion: "Equipo para perforación y exploración de petróleo y gas" },
  { segmento: "20", segmentoDescripcion: "Maquinaria y Accesorios de Minería y Perforación de Pozos", codigo: "2013", descripcion: "Materiales para perforación y operaciones de petróleo y gas" },
  { segmento: "20", segmentoDescripcion: "Maquinaria y Accesorios de Minería y Perforación de Pozos", codigo: "2014", descripcion: "Equipo de producción y operación de petróleo y gas" },
  { segmento: "21", segmentoDescripcion: "Maquinaria y Accesorios para Agricultura, Pesca, Silvicultura y Fauna", codigo: "2110", descripcion: "Maquinaria y equipo para agricultura, silvicultura y paisajismo" },
  { segmento: "21", segmentoDescripcion: "Maquinaria y Accesorios para Agricultura, Pesca, Silvicultura y Fauna", codigo: "2111", descripcion: "Equipo de pesca y acuicultura" },
  { segmento: "22", segmentoDescripcion: "Maquinaria y Accesorios para Construcción y Edificación", codigo: "2210", descripcion: "Maquinaria y equipo pesado de construcción" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2310", descripcion: "Maquinaria para el procesamiento de materias primas" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2311", descripcion: "Maquinaria para el procesamiento de petróleo" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2312", descripcion: "Maquinaria y accesorios de textiles y tejidos" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2313", descripcion: "Maquinaria y equipos lapidarios" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2314", descripcion: "Maquinaria de reparación y accesorios para marroquinería" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2315", descripcion: "Maquinaria, equipo y suministros de procesos industriales" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2316", descripcion: "Máquinas, equipo y suministros para fundición" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2318", descripcion: "Equipo industrial para alimentos y bebidas" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2319", descripcion: "Mezcladores y sus partes y accesorios" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2320", descripcion: "Equipamiento para transferencia de masa" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2321", descripcion: "Maquinaria de fabricación electrónica, equipo y accesorios" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2322", descripcion: "Equipo y maquinaria de procesamiento de pollos" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2323", descripcion: "Equipo y maquinaria de procesamiento de madera y aserrado" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2324", descripcion: "Maquinaria y accesorios para cortar metales" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2325", descripcion: "Maquinaria y accesorios para el formado de metales" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2326", descripcion: "Maquinaria y accesorios para hacer prototipos rápidos" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2327", descripcion: "Maquinaria y accesorios y suministros para soldadura de todas las clases" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2328", descripcion: "Maquinaria para el tratamiento de metal" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2329", descripcion: "Herramientas de maquinado industrial" },
  { segmento: "23", segmentoDescripcion: "Maquinaria y Accesorios de Fabricación y Transformación Industrial", codigo: "2330", descripcion: "Maquinaria y equipo para cable" },
  { segmento: "24", segmentoDescripcion: "Maquinaria, Accesorios y Suministros para Manejo, Acondicionamiento y Almacenamiento de Materiales", codigo: "2410", descripcion: "Maquinaria y equipo para manejo de materiales" },
  { segmento: "24", segmentoDescripcion: "Maquinaria, Accesorios y Suministros para Manejo, Acondicionamiento y Almacenamiento de Materiales", codigo: "2411", descripcion: "Recipientes y almacenamiento" },
  { segmento: "24", segmentoDescripcion: "Maquinaria, Accesorios y Suministros para Manejo, Acondicionamiento y Almacenamiento de Materiales", codigo: "2412", descripcion: "Materiales de empaque" },
  { segmento: "24", segmentoDescripcion: "Maquinaria, Accesorios y Suministros para Manejo, Acondicionamiento y Almacenamiento de Materiales", codigo: "2413", descripcion: "Refrigeración industrial" },
  { segmento: "24", segmentoDescripcion: "Maquinaria, Accesorios y Suministros para Manejo, Acondicionamiento y Almacenamiento de Materiales", codigo: "2414", descripcion: "Suministros de embalaje" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2510", descripcion: "Vehículos de motor" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2511", descripcion: "Transporte marítimo" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2512", descripcion: "Maquinaria y equipo para ferrocarril y tranvías" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2513", descripcion: "Aeronaves" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2515", descripcion: "Naves espaciales" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2516", descripcion: "Bicicletas no motorizadas" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2517", descripcion: "Componentes y sistemas de transporte" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2518", descripcion: "Carrocerías y remolques" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2519", descripcion: "Equipo para servicios de transporte" },
  { segmento: "25", segmentoDescripcion: "Vehículos Comerciales, Militares y Particulares, Accesorios y Componentes", codigo: "2520", descripcion: "Sistemas componentes y equipos aeroespaciales" },
  { segmento: "26", segmentoDescripcion: "Maquinaria y Accesorios para Generación y Distribución de Energía", codigo: "2610", descripcion: "Fuentes de energía" },
  { segmento: "26", segmentoDescripcion: "Maquinaria y Accesorios para Generación y Distribución de Energía", codigo: "2611", descripcion: "Baterías y generadores y transmisión de energía cinética" },
  { segmento: "26", segmentoDescripcion: "Maquinaria y Accesorios para Generación y Distribución de Energía", codigo: "2612", descripcion: "Alambres, cables y arneses" },
  { segmento: "26", segmentoDescripcion: "Maquinaria y Accesorios para Generación y Distribución de Energía", codigo: "2613", descripcion: "Generación de energía" },
  { segmento: "26", segmentoDescripcion: "Maquinaria y Accesorios para Generación y Distribución de Energía", codigo: "2614", descripcion: "Maquinaria y equipo para energía atómica o nuclear" },
  { segmento: "27", segmentoDescripcion: "Herramientas y Maquinaria General", codigo: "2711", descripcion: "Herramientas de mano" },
  { segmento: "27", segmentoDescripcion: "Herramientas y Maquinaria General", codigo: "2712", descripcion: "Maquinaria y equipo hidráulico" },
  { segmento: "27", segmentoDescripcion: "Herramientas y Maquinaria General", codigo: "2713", descripcion: "Maquinaria y equipo neumático" },
  { segmento: "27", segmentoDescripcion: "Herramientas y Maquinaria General", codigo: "2714", descripcion: "Herramientas especializadas automotrices" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3010", descripcion: "Componentes estructurales y formas básicas" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3011", descripcion: "Hormigón, cemento y yeso" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3012", descripcion: "Carreteras y paisaje" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3013", descripcion: "Productos de construcción estructurales" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3014", descripcion: "Aislamiento" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3015", descripcion: "Materiales para acabado de exteriores" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3016", descripcion: "Materiales de acabado de interiores" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3017", descripcion: "Puertas y ventanas y vidrio" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3018", descripcion: "Instalaciones de plomería" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3019", descripcion: "Equipo de apoyo para Construcción y Mantenimiento" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3024", descripcion: "Componentes de construcción de estructura portátil" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3025", descripcion: "Estructuras y materiales de minería subterránea" },
  { segmento: "30", segmentoDescripcion: "Componentes y Suministros para Estructuras, Edificación, Construcción y Obras Civiles", codigo: "3026", descripcion: "Materiales estructurales" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3110", descripcion: "Piezas de fundición y ensambles de piezas de fundición" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3111", descripcion: "Extrusiones" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3112", descripcion: "Piezas fundidas maquinadas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3113", descripcion: "Forjaduras" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3114", descripcion: "Molduras" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3115", descripcion: "Cuerda, cadena, cable, alambre y correa" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3116", descripcion: "Ferretería" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3117", descripcion: "Rodamientos, cojinetes ruedas y engranajes" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3118", descripcion: "Empaques, glándulas, fundas y cubiertas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3119", descripcion: "Materiales de afilado pulido y alisado" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3120", descripcion: "Adhesivos y selladores" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3121", descripcion: "Pinturas y bases y acabados" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3122", descripcion: "Extractos de teñir y de curtir" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3123", descripcion: "Materia prima en placas o barras labradas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3124", descripcion: "Óptica industrial" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3125", descripcion: "Sistemas de control neumático, hidráulico o eléctrico" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3126", descripcion: "Cubiertas, cajas y envolturas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3127", descripcion: "Piezas hechas a máquina" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3128", descripcion: "Componentes de placa y estampados" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3129", descripcion: "Extrusiones maquinadas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3130", descripcion: "Forjas labradas" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3131", descripcion: "Ensambles de tubería fabricada" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3132", descripcion: "Ensambles fabricados de material en barras" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3133", descripcion: "Ensambles estructurales fabricados" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3134", descripcion: "Ensambles de lámina fabricado" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3135", descripcion: "Ensambles de tubería fabricada" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3136", descripcion: "Ensambles de placa fabricados" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3137", descripcion: "Refractarios" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3138", descripcion: "Imanes y materiales magnéticos" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3139", descripcion: "Maquinados" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3140", descripcion: "Empaques" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3141", descripcion: "Sellos" },
  { segmento: "31", segmentoDescripcion: "Componentes y Suministros de Manufactura", codigo: "3142", descripcion: "Partes sinterizadas" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3210", descripcion: "Circuitos impresos, circuitos integrados y micro ensamblajes" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3211", descripcion: "Dispositivo semiconductor discreto" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3212", descripcion: "Componentes pasivos discretos" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3213", descripcion: "Piezas de componentes y hardware electrónicos y accesorios" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3214", descripcion: "Dispositivos de tubo electrónico y accesorios" },
  { segmento: "32", segmentoDescripcion: "Componentes y Suministros Electrónicos", codigo: "3215", descripcion: "Dispositivos y componentes y accesorios de control de automatización" },
  { segmento: "39", segmentoDescripcion: "Componentes, Accesorios y Suministros de Sistemas Eléctricos e Iluminación", codigo: "3910", descripcion: "Lámparas y bombillas y componentes para lámparas" },
  { segmento: "39", segmentoDescripcion: "Componentes, Accesorios y Suministros de Sistemas Eléctricos e Iluminación", codigo: "3911", descripcion: "Iluminación, artefactos y accesorios" },
  { segmento: "39", segmentoDescripcion: "Componentes, Accesorios y Suministros de Sistemas Eléctricos e Iluminación", codigo: "3912", descripcion: "Equipos, suministros y componentes eléctricos" },
  { segmento: "39", segmentoDescripcion: "Componentes, Accesorios y Suministros de Sistemas Eléctricos e Iluminación", codigo: "3913", descripcion: "Dispositivos y accesorios y suministros de manejo de cable eléctrico" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4010", descripcion: "Calefacción, ventilación y circulación del aire" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4014", descripcion: "Distribución de fluidos y gas" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4015", descripcion: "Bombas y compresores industriales" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4016", descripcion: "Filtrado y purificación industrial" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4017", descripcion: "Instalaciones de tubos y entubamientos" },
  { segmento: "40", segmentoDescripcion: "Componentes y Equipos para Distribución y Sistemas de Acondicionamiento", codigo: "4018", descripcion: "Instalaciones de tubos y tuberías" },
  { segmento: "41", segmentoDescripcion: "Equipos y Suministros de Laboratorio, Medición, Observación y Pruebas", codigo: "4110", descripcion: "Equipo de laboratorio y científico" },
  { segmento: "41", segmentoDescripcion: "Equipos y Suministros de Laboratorio, Medición, Observación y Pruebas", codigo: "4111", descripcion: "Instrumentos de medida, observación y ensayo" },
  { segmento: "41", segmentoDescripcion: "Equipos y Suministros de Laboratorio, Medición, Observación y Pruebas", codigo: "4112", descripcion: "Suministros y accesorios de laboratorio" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4212", descripcion: "Equipos y suministros veterinarios" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4213", descripcion: "Telas y vestidos médicos" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4214", descripcion: "Suministros, productos de tratamiento y cuidado del enfermo" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4215", descripcion: "Equipos y suministros dentales" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4216", descripcion: "Equipo de diálisis y suministros" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4217", descripcion: "Productos para los servicios médicos de urgencias y campo" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4218", descripcion: "Productos de examen y control del paciente" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4219", descripcion: "Productos de centro médico" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4220", descripcion: "Productos de hacer imágenes diagnósticas médicas y de medicina nuclear" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4221", descripcion: "Ayuda para personas con desafíos físicos para vivir independiente" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4222", descripcion: "Productos para administración intravenosa y arterial" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4223", descripcion: "Nutrición clínica" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4224", descripcion: "Productos medicinales de deportes y ortopédicos y prótesis" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4225", descripcion: "Productos de rehabilitación y terapia ocupacional y física" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4226", descripcion: "Equipo y suministros post mortem y funerarios" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4227", descripcion: "Productos de resucitación, anestesia y respiratorio" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4228", descripcion: "Productos para la esterilización médica" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4229", descripcion: "Productos quirúrgicos" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4230", descripcion: "Suministros para formación y estudios de medicina" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4231", descripcion: "Productos para el cuidado de heridas" },
  { segmento: "42", segmentoDescripcion: "Equipo Médico, Accesorios y Suministros", codigo: "4232", descripcion: "Implantes ortopédicos quirúrgicos" },
  { segmento: "43", segmentoDescripcion: "Difusión de Tecnologías de Información y Telecomunicaciones", codigo: "4319", descripcion: "Dispositivos de comunicaciones y accesorios" },
  { segmento: "43", segmentoDescripcion: "Difusión de Tecnologías de Información y Telecomunicaciones", codigo: "4320", descripcion: "Componentes para tecnología de la información, difusión o telecomunicaciones" },
  { segmento: "43", segmentoDescripcion: "Difusión de Tecnologías de Información y Telecomunicaciones", codigo: "4321", descripcion: "Equipo informático y accesorios" },
  { segmento: "43", segmentoDescripcion: "Difusión de Tecnologías de Información y Telecomunicaciones", codigo: "4322", descripcion: "Equipos o plataformas y accesorios de redes multimedia o de voz y datos" },
  { segmento: "43", segmentoDescripcion: "Difusión de Tecnologías de Información y Telecomunicaciones", codigo: "4323", descripcion: "Software" },
  { segmento: "44", segmentoDescripcion: "Equipos de Oficina, Accesorios y Suministros", codigo: "4410", descripcion: "Maquinaria, suministros y accesorios de oficina" },
  { segmento: "44", segmentoDescripcion: "Equipos de Oficina, Accesorios y Suministros", codigo: "4411", descripcion: "Accesorios de oficina y escritorio" },
  { segmento: "44", segmentoDescripcion: "Equipos de Oficina, Accesorios y Suministros", codigo: "4412", descripcion: "Suministros de oficina" },
  { segmento: "45", segmentoDescripcion: "Equipos y Suministros para Impresión, Fotografía y Audiovisuales", codigo: "4510", descripcion: "Equipo de imprenta y publicación" },
  { segmento: "45", segmentoDescripcion: "Equipos y Suministros para Impresión, Fotografía y Audiovisuales", codigo: "4511", descripcion: "Equipos de audio y video para presentación y composición" },
  { segmento: "45", segmentoDescripcion: "Equipos y Suministros para Impresión, Fotografía y Audiovisuales", codigo: "4512", descripcion: "Equipo de vídeo, filmación o fotografía" },
  { segmento: "45", segmentoDescripcion: "Equipos y Suministros para Impresión, Fotografía y Audiovisuales", codigo: "4513", descripcion: "Medios fotográficos y de grabación" },
  { segmento: "45", segmentoDescripcion: "Equipos y Suministros para Impresión, Fotografía y Audiovisuales", codigo: "4514", descripcion: "Suministros fotográficos para cine" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4610", descripcion: "Armas ligeras y munición" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4611", descripcion: "Armas de guerra convencionales" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4612", descripcion: "Misiles" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4613", descripcion: "Cohetes y subsistemas" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4614", descripcion: "Lanzadores" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4615", descripcion: "Protección del Orden Público" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4616", descripcion: "Seguridad y control público" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4617", descripcion: "Seguridad, vigilancia y detección" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4618", descripcion: "Seguridad y protección personal" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4619", descripcion: "Protección contra incendios" },
  { segmento: "46", segmentoDescripcion: "Equipos y Suministros de Defensa, Orden Público, Protección, Vigilancia y Seguridad", codigo: "4620", descripcion: "Equipo de entrenamiento de seguridad física e industrial, defensa y orden público" },
  { segmento: "47", segmentoDescripcion: "Equipos de Limpieza y Suministros", codigo: "4710", descripcion: "Tratamiento, suministros y eliminación de agua y aguas residuales" },
  { segmento: "47", segmentoDescripcion: "Equipos de Limpieza y Suministros", codigo: "4711", descripcion: "Equipo industrial de lavandería y lavado en seco" },
  { segmento: "47", segmentoDescripcion: "Equipos de Limpieza y Suministros", codigo: "4712", descripcion: "Equipo de aseo" },
  { segmento: "47", segmentoDescripcion: "Equipos de Limpieza y Suministros", codigo: "4713", descripcion: "Suministros de aseo y limpieza" },
  { segmento: "48", segmentoDescripcion: "Maquinaria, Equipo y Suministros para la Industria de Servicios", codigo: "4810", descripcion: "Equipos de servicios de alimentación para instituciones" },
  { segmento: "48", segmentoDescripcion: "Maquinaria, Equipo y Suministros para la Industria de Servicios", codigo: "4811", descripcion: "Máquinas expendedoras" },
  { segmento: "48", segmentoDescripcion: "Maquinaria, Equipo y Suministros para la Industria de Servicios", codigo: "4812", descripcion: "Equipo de Juego o de Apostar" },
  { segmento: "48", segmentoDescripcion: "Maquinaria, Equipo y Suministros para la Industria de Servicios", codigo: "4813", descripcion: "Equipo y materiales funerarios" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4910", descripcion: "Coleccionables y condecoraciones" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4912", descripcion: "Equipos y accesorios para acampada y exteriores" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4913", descripcion: "Equipos de pesca y caza" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4914", descripcion: "Equipos para deportes acuáticos" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4915", descripcion: "Equipos para deportes de invierno" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4916", descripcion: "Equipos deportivos para campos y canchas" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4917", descripcion: "Equipos de gimnasia y boxeo" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4918", descripcion: "Juegos, equipo de tiro y mesa" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4920", descripcion: "Equipo para entrenamiento físico" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4921", descripcion: "Otros deportes" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4922", descripcion: "Equipo y accesorios para deportes" },
  { segmento: "49", segmentoDescripcion: "Equipos, Suministros y Accesorios para Deportes y Recreación", codigo: "4924", descripcion: "Equipo de recreo, parques infantiles y equipo y suministros de natación y de spa" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5010", descripcion: "Frutos secos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5011", descripcion: "Productos de carne y aves de corral" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5012", descripcion: "Pescados y mariscos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5013", descripcion: "Productos lácteos y huevos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5015", descripcion: "Aceites y grasas comestibles" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5016", descripcion: "Chocolates, azúcares, edulcorantes y productos de confitería" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5017", descripcion: "Condimentos y conservantes" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5018", descripcion: "Productos de panadería" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5019", descripcion: "Alimentos preparados y conservados" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5020", descripcion: "Bebidas" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5021", descripcion: "Tabaco y productos de fumar y substitutos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5022", descripcion: "Productos de cereales y legumbres" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5030", descripcion: "Fruta fresca" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5031", descripcion: "Fruta orgánica fresca" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5032", descripcion: "Fruta seca" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5033", descripcion: "Fruta orgánica seca" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5034", descripcion: "Fruta congelada" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5035", descripcion: "Fruta orgánica congelada" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5036", descripcion: "Fruta en lata o en frasco" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5037", descripcion: "Fruta orgánica en lata o en frasco" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5038", descripcion: "Puré de frutas" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5040", descripcion: "Vegetales frescos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5041", descripcion: "Vegetales orgánicos frescos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5042", descripcion: "Vegetales secos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5043", descripcion: "Vegetales orgánicos secos" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5044", descripcion: "Vegetales congelados" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5045", descripcion: "Vegetales orgánicos congelados" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5046", descripcion: "Vegetales en lata o en frasco" },
  { segmento: "50", segmentoDescripcion: "Alimentos, Bebidas y Tabaco", codigo: "5047", descripcion: "Vegetales orgánicos en lata o en frasco" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5110", descripcion: "Medicamentos anti infecciosos" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5111", descripcion: "Agentes antitumorales" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5112", descripcion: "Medicamentos cardiovasculares" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5113", descripcion: "Medicamentos hematólogos" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5114", descripcion: "Medicamentos para el sistema nervioso central" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5115", descripcion: "Medicamentos para el sistema nervioso autónomo" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5116", descripcion: "Medicamentos que afectan al sistema respiratorio" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5117", descripcion: "Medicamentos que afectan al sistema gastrointestinal" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5118", descripcion: "Hormonas y antagonistas hormonales" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5119", descripcion: "Agentes que afectan el agua y los electrolitos" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5120", descripcion: "Medicamentos inmunomoduladores" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5121", descripcion: "Categorías de medicamentos varios" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5124", descripcion: "Fármacos que afectan a los oídos, los ojos, la nariz y la piel" },
  { segmento: "51", segmentoDescripcion: "Medicamentos y Productos Farmacéuticos", codigo: "5125", descripcion: "Suplementos alimenticios veterinarios" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5210", descripcion: "Revestimientos de suelos" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5212", descripcion: "Ropa de cama, mantelerías, paños de cocina y toallas" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5213", descripcion: "Tratamientos de ventanas" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5214", descripcion: "Aparatos electrodomésticos" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5215", descripcion: "Utensilios de cocina domésticos" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5216", descripcion: "Electrónica de consumo" },
  { segmento: "52", segmentoDescripcion: "Artículos Domésticos, Suministros y Productos Electrónicos de Consumo", codigo: "5217", descripcion: "Tratamientos de pared doméstica" },
  { segmento: "53", segmentoDescripcion: "Ropa, Maletas y Productos de Aseo Personal", codigo: "5310", descripcion: "Ropa" },
  { segmento: "53", segmentoDescripcion: "Ropa, Maletas y Productos de Aseo Personal", codigo: "5311", descripcion: "Calzado" },
  { segmento: "53", segmentoDescripcion: "Ropa, Maletas y Productos de Aseo Personal", codigo: "5312", descripcion: "Maletas, bolsos de mano, mochilas y estuches" },
  { segmento: "53", segmentoDescripcion: "Ropa, Maletas y Productos de Aseo Personal", codigo: "5313", descripcion: "Artículos de tocador y cuidado personal" },
  { segmento: "53", segmentoDescripcion: "Ropa, Maletas y Productos de Aseo Personal", codigo: "5314", descripcion: "Fuentes y accesorios de costura" },
  { segmento: "54", segmentoDescripcion: "Productos para Relojería, Joyería y Piedras Preciosas", codigo: "5410", descripcion: "Joyería" },
  { segmento: "54", segmentoDescripcion: "Productos para Relojería, Joyería y Piedras Preciosas", codigo: "5411", descripcion: "Relojes" },
  { segmento: "54", segmentoDescripcion: "Productos para Relojería, Joyería y Piedras Preciosas", codigo: "5412", descripcion: "Gemas" },
  { segmento: "55", segmentoDescripcion: "Publicaciones Impresas, Publicaciones Electrónicas y Accesorios", codigo: "5510", descripcion: "Medios impresos" },
  { segmento: "55", segmentoDescripcion: "Publicaciones Impresas, Publicaciones Electrónicas y Accesorios", codigo: "5511", descripcion: "Material electrónico de referencia" },
  { segmento: "55", segmentoDescripcion: "Publicaciones Impresas, Publicaciones Electrónicas y Accesorios", codigo: "5512", descripcion: "Etiquetado y accesorios" },
  { segmento: "56", segmentoDescripcion: "Muebles, Mobiliario y Decoración", codigo: "5610", descripcion: "Muebles de alojamiento" },
  { segmento: "56", segmentoDescripcion: "Muebles, Mobiliario y Decoración", codigo: "5611", descripcion: "Muebles comerciales e industriales" },
  { segmento: "56", segmentoDescripcion: "Muebles, Mobiliario y Decoración", codigo: "5612", descripcion: "Mobiliario institucional, escolar y educativo y accesorios" },
  { segmento: "56", segmentoDescripcion: "Muebles, Mobiliario y Decoración", codigo: "5613", descripcion: "Muebles y accesorios para mercadeo" },
  { segmento: "56", segmentoDescripcion: "Muebles, Mobiliario y Decoración", codigo: "5614", descripcion: "Adornos para el hogar" },
  { segmento: "60", segmentoDescripcion: "Instrumentos Musicales, Juegos, Juguetes, Artes, Artesanías y Equipo Educativo", codigo: "6010", descripcion: "Materiales didácticos profesionales y de desarrollo y accesorios y suministros" },
  { segmento: "60", segmentoDescripcion: "Instrumentos Musicales, Juegos, Juguetes, Artes, Artesanías y Equipo Educativo", codigo: "6011", descripcion: "Decoraciones y suministros del aula" },
  { segmento: "60", segmentoDescripcion: "Instrumentos Musicales, Juegos, Juguetes, Artes, Artesanías y Equipo Educativo", codigo: "6012", descripcion: "Equipo, accesorios y suministros de arte y manualidades" },
  { segmento: "60", segmentoDescripcion: "Instrumentos Musicales, Juegos, Juguetes, Artes, Artesanías y Equipo Educativo", codigo: "6013", descripcion: "Instrumentos musicales, piezas y accesorios" },
  { segmento: "60", segmentoDescripcion: "Instrumentos Musicales, Juegos, Juguetes, Artes, Artesanías y Equipo Educativo", codigo: "6014", descripcion: "Juguetes y juegos" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7010", descripcion: "Pesquerías y acuicultura" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7011", descripcion: "Horticultura" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7012", descripcion: "Servicios de animales vivos" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7013", descripcion: "Preparación, gestión y protección del terreno y del suelo" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7014", descripcion: "Producción, gestión y protección de cultivos" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7015", descripcion: "Silvicultura" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7016", descripcion: "Fauna y flora silvestres" },
  { segmento: "70", segmentoDescripcion: "Servicios de Contratación Agrícola, Pesquera, Forestal y de Fauna", codigo: "7017", descripcion: "Desarrollo y vigilancia de recursos hidráulicos" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7110", descripcion: "Servicios de minería" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7111", descripcion: "Servicios de perforación y prospección petrolífera y de gas" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7112", descripcion: "Servicios de construcción y perforación de pozos" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7113", descripcion: "Servicios de aumento de la extracción y producción de gas y petróleo" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7114", descripcion: "Servicios de restauración y recuperación de gas y petróleo" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7115", descripcion: "Servicios de procesamiento y gestión de datos de petróleo y gas" },
  { segmento: "71", segmentoDescripcion: "Servicios de Minería, Petróleo y Gas", codigo: "7116", descripcion: "Servicios de gerencia de proyectos en pozos de petróleo y gas" },
  { segmento: "72", segmentoDescripcion: "Servicios de Edificación, Construcción de Instalaciones y Mantenimiento", codigo: "7210", descripcion: "Servicios de mantenimiento y reparaciones de construcciones e instalaciones" },
  { segmento: "72", segmentoDescripcion: "Servicios de Edificación, Construcción de Instalaciones y Mantenimiento", codigo: "7211", descripcion: "Servicios de construcción de edificaciones residenciales" },
  { segmento: "72", segmentoDescripcion: "Servicios de Edificación, Construcción de Instalaciones y Mantenimiento", codigo: "7212", descripcion: "Servicios de construcción de edificaciones no residenciales" },
  { segmento: "72", segmentoDescripcion: "Servicios de Edificación, Construcción de Instalaciones y Mantenimiento", codigo: "7214", descripcion: "Servicios de construcción pesada" },
  { segmento: "72", segmentoDescripcion: "Servicios de Edificación, Construcción de Instalaciones y Mantenimiento", codigo: "7215", descripcion: "Servicios de mantenimiento y construcción de comercio especializado" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7310", descripcion: "Industrias de plásticos y productos químicos" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7311", descripcion: "Industrias de la madera y el papel" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7312", descripcion: "Industrias del metal y de minerales" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7313", descripcion: "Industrias de alimentos y bebidas" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7314", descripcion: "Industrias de fibras, textiles y de tejidos" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7315", descripcion: "Servicios de apoyo a la fabricación" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7316", descripcion: "Fabricación de maquinaria y equipo de transporte" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7317", descripcion: "Fabricación de productos eléctricos e instrumentos de precisión" },
  { segmento: "73", segmentoDescripcion: "Servicios de Producción Industrial y Manufactura", codigo: "7318", descripcion: "Servicios de maquinado y procesado" },
  { segmento: "76", segmentoDescripcion: "Servicios de Limpieza, Descontaminación y Tratamiento de Residuos", codigo: "7610", descripcion: "Servicios de descontaminación" },
  { segmento: "76", segmentoDescripcion: "Servicios de Limpieza, Descontaminación y Tratamiento de Residuos", codigo: "7611", descripcion: "Servicios de aseo y limpieza" },
  { segmento: "76", segmentoDescripcion: "Servicios de Limpieza, Descontaminación y Tratamiento de Residuos", codigo: "7612", descripcion: "Eliminación y tratamiento de desechos" },
  { segmento: "76", segmentoDescripcion: "Servicios de Limpieza, Descontaminación y Tratamiento de Residuos", codigo: "7613", descripcion: "Limpieza de residuos tóxicos y peligrosos" },
  { segmento: "77", segmentoDescripcion: "Servicios Medioambientales", codigo: "7710", descripcion: "Gestión medioambiental" },
  { segmento: "77", segmentoDescripcion: "Servicios Medioambientales", codigo: "7711", descripcion: "Protección medioambiental" },
  { segmento: "77", segmentoDescripcion: "Servicios Medioambientales", codigo: "7712", descripcion: "Seguimiento, control y rehabilitación de la contaminación" },
  { segmento: "77", segmentoDescripcion: "Servicios Medioambientales", codigo: "7713", descripcion: "Servicios de seguimiento, control o rehabilitación de contaminantes" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7810", descripcion: "Transporte de correo y carga" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7811", descripcion: "Transporte de pasajeros" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7812", descripcion: "Manejo y embalaje de material" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7813", descripcion: "Almacenaje" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7814", descripcion: "Servicios de transporte" },
  { segmento: "78", segmentoDescripcion: "Servicios de Transporte, Almacenaje y Correo", codigo: "7818", descripcion: "Servicios de mantenimiento o reparaciones de transportes" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8010", descripcion: "Servicios de asesoría de gestión" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8011", descripcion: "Servicios de recursos humanos" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8012", descripcion: "Servicios legales" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8013", descripcion: "Servicios inmobiliarios" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8014", descripcion: "Comercialización y distribución" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8015", descripcion: "Política comercial y servicios" },
  { segmento: "80", segmentoDescripcion: "Servicios de Gestión, Servicios Profesionales de Empresa y Servicios Administrativos", codigo: "8016", descripcion: "Servicios de administración de empresas" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8110", descripcion: "Servicios profesionales de ingeniería" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8111", descripcion: "Servicios informáticos" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8112", descripcion: "Economía" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8113", descripcion: "Estadística" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8114", descripcion: "Tecnologías de fabricación" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8115", descripcion: "Servicios de pedología" },
  { segmento: "81", segmentoDescripcion: "Servicios Basados en Ingeniería, Investigación y Tecnología", codigo: "8116", descripcion: "Entrega de servicios de tecnología de información" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8210", descripcion: "Publicidad" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8211", descripcion: "Escritura y traducciones" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8212", descripcion: "Servicios de reproducción" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8213", descripcion: "Servicios fotográficos" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8214", descripcion: "Diseño gráfico" },
  { segmento: "82", segmentoDescripcion: "Servicios Editoriales, de Diseño, de Artes Gráficas y Bellas Artes", codigo: "8215", descripcion: "Artistas e intérpretes profesionales" },
  { segmento: "83", segmentoDescripcion: "Servicios Públicos y Servicios Relacionados con el Sector Público", codigo: "8310", descripcion: "Servicios públicos" },
  { segmento: "83", segmentoDescripcion: "Servicios Públicos y Servicios Relacionados con el Sector Público", codigo: "8311", descripcion: "Servicios de medios de telecomunicaciones" },
  { segmento: "83", segmentoDescripcion: "Servicios Públicos y Servicios Relacionados con el Sector Público", codigo: "8312", descripcion: "Servicios de información" },
  { segmento: "84", segmentoDescripcion: "Servicios Financieros y de Seguros", codigo: "8410", descripcion: "Finanzas de desarrollo" },
  { segmento: "84", segmentoDescripcion: "Servicios Financieros y de Seguros", codigo: "8411", descripcion: "Servicios de contabilidad y auditorias" },
  { segmento: "84", segmentoDescripcion: "Servicios Financieros y de Seguros", codigo: "8412", descripcion: "Banca e inversiones" },
  { segmento: "84", segmentoDescripcion: "Servicios Financieros y de Seguros", codigo: "8413", descripcion: "Servicios de seguros y pensiones" },
  { segmento: "84", segmentoDescripcion: "Servicios Financieros y de Seguros", codigo: "8414", descripcion: "Agencias de crédito" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8510", descripcion: "Servicios integrales de salud" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8511", descripcion: "Prevención y control de enfermedades" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8512", descripcion: "Práctica médica" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8513", descripcion: "Ciencia médica, investigación y experimentación" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8514", descripcion: "Medicina alternativa y holística" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8515", descripcion: "Servicios alimenticios y de nutrición" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8516", descripcion: "Servicios de mantenimiento, renovación y reparación de equipo médico quirúrgico" },
  { segmento: "85", segmentoDescripcion: "Servicios de Salud", codigo: "8517", descripcion: "Servicios de muerte y soporte al fallecimiento" },
  { segmento: "86", segmentoDescripcion: "Servicios Educativos y de Formación", codigo: "8610", descripcion: "Formación profesional" },
  { segmento: "86", segmentoDescripcion: "Servicios Educativos y de Formación", codigo: "8611", descripcion: "Sistemas educativos alternativos" },
  { segmento: "86", segmentoDescripcion: "Servicios Educativos y de Formación", codigo: "8612", descripcion: "Instituciones educativas" },
  { segmento: "86", segmentoDescripcion: "Servicios Educativos y de Formación", codigo: "8613", descripcion: "Servicios educativos especializados" },
  { segmento: "86", segmentoDescripcion: "Servicios Educativos y de Formación", codigo: "8614", descripcion: "Instalaciones educativas" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9010", descripcion: "Restaurantes y catering (servicios de comidas y bebidas)" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9011", descripcion: "Instalaciones hoteleras, alojamientos y centros de encuentros" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9012", descripcion: "Facilitación de viajes" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9013", descripcion: "Artes interpretativas" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9014", descripcion: "Deportes comerciales" },
  { segmento: "90", segmentoDescripcion: "Servicios de Viajes, Alimentación, Alojamiento y Entretenimiento", codigo: "9015", descripcion: "Servicios de entretenimiento" },
  { segmento: "91", segmentoDescripcion: "Servicios Personales y Domésticos", codigo: "9110", descripcion: "Aspecto personal" },
  { segmento: "91", segmentoDescripcion: "Servicios Personales y Domésticos", codigo: "9111", descripcion: "Asistencia doméstica y personal" },
  { segmento: "92", segmentoDescripcion: "Servicios de Defensa Nacional, Orden Público, Seguridad y Vigilancia", codigo: "9210", descripcion: "Orden público y seguridad" },
  { segmento: "92", segmentoDescripcion: "Servicios de Defensa Nacional, Orden Público, Seguridad y Vigilancia", codigo: "9211", descripcion: "Servicios militares o defensa nacional" },
  { segmento: "92", segmentoDescripcion: "Servicios de Defensa Nacional, Orden Público, Seguridad y Vigilancia", codigo: "9212", descripcion: "Seguridad y protección personal" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9310", descripcion: "Sistemas e instituciones políticas" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9311", descripcion: "Condiciones sociopolíticas" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9312", descripcion: "Relaciones internacionales" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9313", descripcion: "Ayuda y asistencia humanitaria" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9314", descripcion: "Servicios comunitarios y sociales" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9315", descripcion: "Servicios de administración y financiación pública" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9316", descripcion: "Tributación" },
  { segmento: "93", segmentoDescripcion: "Servicios Políticos y de Asuntos Cívicos", codigo: "9317", descripcion: "Política y regulación comercial" },
  { segmento: "94", segmentoDescripcion: "Organizaciones y Clubes", codigo: "9410", descripcion: "Organizaciones laborales" },
  { segmento: "94", segmentoDescripcion: "Organizaciones y Clubes", codigo: "9411", descripcion: "Organizaciones religiosas" },
  { segmento: "94", segmentoDescripcion: "Organizaciones y Clubes", codigo: "9412", descripcion: "Clubes" },
  { segmento: "94", segmentoDescripcion: "Organizaciones y Clubes", codigo: "9413", descripcion: "Organizaciones, asociaciones y movimientos cívicos" },
  { segmento: "95", segmentoDescripcion: "Terrenos, Edificios, Estructuras y Vías", codigo: "9510", descripcion: "Parcelas de tierra" },
  { segmento: "95", segmentoDescripcion: "Terrenos, Edificios, Estructuras y Vías", codigo: "9511", descripcion: "Vías" },
  { segmento: "95", segmentoDescripcion: "Terrenos, Edificios, Estructuras y Vías", codigo: "9512", descripcion: "Estructuras y edificios permanentes" },
  { segmento: "95", segmentoDescripcion: "Terrenos, Edificios, Estructuras y Vías", codigo: "9513", descripcion: "Estructuras y edificios móviles" },
  { segmento: "95", segmentoDescripcion: "Terrenos, Edificios, Estructuras y Vías", codigo: "9514", descripcion: "Estructuras y edificios prefabricados" },
];

export const consultarCPBS = (busqueda) => {
  if (!busqueda) return [];

  const normalizar = (valor) =>
    String(valor ?? "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const texto = normalizar(busqueda);

  return CPBS.filter((item) => normalizar(item.segmento).includes(texto) || normalizar(item.segmentoDescripcion).includes(texto) || normalizar(item.codigo).includes(texto) || normalizar(item.descripcion).includes(texto));
};
export const data_descuento = [
  { value: "5", label: "5 %" },
  { value: "10", label: "10 %" },
  { value: "15", label: "15 %" },
  { value: "20", label: "20 %" },
  { value: "25", label: "25 %" },
  { value: "30", label: "30 %" },
  { value: "50", label: "50 %" },
];
export const dataTipo = [
  { value: "0", label: "null", objName: "null" },
  { value: "1", label: "Administrador", objName: "tipo" },
  { value: "2", label: "Vendedor", objName: "tipo" },
  { value: "3", label: "Restaurante tablet", objName: "tipo" },
  { value: "4", label: "Restaurante factura", objName: "tipo" },
];
export const monthname = [{ name: "Enero" }, { name: "Febrero" }, { name: "Marzo" }, { name: "Abril" }, { name: "Mayo" }, { name: "Junio" }, { name: "Julio" }, { name: "Agosto" }, { name: "Septiembre" }, { name: "Octubre" }, { name: "Noviembre" }, { name: "Diciembre" }];
export const dataDropdownTipo = [
  { value: "1", label: "Administrador", objName: "tipo" },
  { value: "2", label: "Vendedor", objName: "tipo" },
  { value: "3", label: "Tablet", objName: "restaurante" },
  { value: "4", label: "Restaurante factura", objName: "restaurante" },
];

export const dataDropdownPrint = [
  { value: "1", label: "Factura electrónica PDF", objName: "print" },
  { value: "2", label: "Factura electrónica recibo térmico", objName: "print" },
  // { value: '3', label: 'Comprobante NO fiscal',objName:"print" },
  { value: "4", label: "Factura electrónica PDF & Recibo térmico", objName: "print" },
];

export async function put_compania(data) {
  const response = await fetch(url + "SettingController/put_compania", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function post_pdf_informex(payload) {
  const response = await fetch(url + "ReportsController/post_pdf_informex", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_pdf_cotizacion(payload) {
  const response = await fetch(url + "ReportsController/post_pdf_cotizacion", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function post_pdf_cxc(payload) {
  const response = await fetch(url + "ReportsController/post_pdf_print_cxc_orden", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      setTimeout(() => {
        window.open(IP + "/sys_mbo/pdf/ordenes/reportecxc.pdf?" + moment(new Date()).format("YYYYMMDDHHmmss"));
      }, 1000);
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function get_report_historial_clientes(cli_id) {
  var urlFetch = url + "ReportsController/get_report_historial_clientes/" + cli_id + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_series_by_articulo_all({ art_id, sucursal }) {
  var urlFetch = url + "ArticuloController/get_series_by_articulo_all/" + art_id + "/" + sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_series_by_articulo({ art_id, sucursal }) {
  var urlFetch = url + "ArticuloController/get_series_by_articulo/" + art_id + "/" + sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_caja_data(caja_n) {
  var urlFetch = url + "SettingController/get_caja_data/" + caja_n + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_compania(usr_key_login, compania) {
  var urlFetch = url + "SettingController/get_compania/" + usr_key_login + "/" + compania + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_compania_all() {
  var urlFetch = url + "SettingController/get_compania_all/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_bod_bodega(data) {
  const response = await fetch(url + "BodegaController/post_bod_bodega", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_bod_bodega_principal(data) {
  const response = await fetch(url + "BodegaController/put_bod_bodega_principal", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_bod_bodega_sts(data) {
  const response = await fetch(url + "BodegaController/put_bod_bodega_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_bod_bodega(data) {
  const response = await fetch(url + "BodegaController/put_bod_bodega", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function get_bod_bodega(usr_sucursal) {
  var urlFetch = url + "BodegaController/get_bod_bodega/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function descargar_factura_pdf(data) {
  try {
    const response = await fetch(url + "GastosController/descargar_factura_pdf", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const blob = await response.blob(); // Obtener el archivo como Blob
    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = urlBlob;
    a.download = data + ".pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(urlBlob);
  } catch (e) {
    console.error("Error al descargar el archivo PDF:", e);
  }
}
export async function descargar_zip(data) {
  try {
    // Realizar la petición POST para obtener el archivo ZIP
    const response = await fetch(url + "GastosController/descargar_zip", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Error en la descarga del archivo ZIP");
    }

    const blob = await response.blob(); // Obtener el archivo como Blob

    // Crear un enlace temporal para la descarga
    const urlBlob = window.URL.createObjectURL(blob);

    // Crear un elemento <a> para simular la descarga
    const a = document.createElement("a");
    a.href = urlBlob;
    a.download = "gastos.zip"; // Nombre del archivo descargado

    // Agregar el <a> al DOM y simular un clic
    document.body.appendChild(a);
    a.click();

    // Eliminar el <a> del DOM
    document.body.removeChild(a);

    // Liberar el objeto URL para evitar fugas de memoria
    window.URL.revokeObjectURL(urlBlob);
  } catch (e) {
    console.error("Error al descargar el archivo ZIP:", e);
  }
}
export async function descargar_zips(data) {
  const response = await fetch(url + "GastosController/descargar_zip", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.blob())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_cli_cliente(data) {
  const response = await fetch(url + "ClienteController/post_cli_cliente", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function print_etiqueta_termico({ formArticulos }) {
  $.ajax({
    url: IP_FE_LOCAL + "/sys_mbo/tax_sysm/consultarRucDv.php?action=print_etiqueta_termico",
    data: JSON.stringify(formArticulos),
    type: "POST",
    success: function (response) {
      if (response === 1) {
      } else {
      }
    },
  });
  return true;
}

export async function print_recibo_cocina({ form }) {
  const headers = {};
  if (IP_FE_COMANDA.includes("ngrok-free.dev")) {
    headers["ngrok-skip-browser-warning"] = "true";
  }
  $.ajax({
    url: IP_FE_COMANDA + "/sys_mbo/tax_sysm/consultarRucDv.php?action=print_recibo_cocina",
    data: JSON.stringify(form),
    type: "POST",
    headers: headers,
    success: function (response) {
      if (response === 1) {
      } else {
      }
    },
    error: function (xhr, status, error) {
      console.error("Error imprimiendo comanda:", error);
    },
  });
  return true;
}

export async function print_report_x(data) {
  $.ajax({
    url: IP_FE_LOCAL + "/sys_mbo/tax_sysm/consultarRucDv.php?action=reporte_x",
    data: JSON.stringify(data),
    type: "POST",
    success: function (response) {
      if (response === 1) {
      } else {
      }
    },
  });
  return true;
}
export async function consultar_estadoDocumento({ numeroDocumentoFiscal, codigoSucursalEmisor, fac_id, fac_tipodocumento, punto_facturacion, validacionHKA = false }) {
  try {
    const urlFetch =
      urlFacturaElectronica +
      `consultarRucDv.php?codigoSuc=${encodeURIComponent(codigoSucursalEmisor)}` +
      `&numeroDocumentoFiscal=${encodeURIComponent(numeroDocumentoFiscal)}` +
      `&punto_facturacion=${encodeURIComponent(punto_facturacion)}` +
      `&tipoDocumento=${encodeURIComponent(fac_tipodocumento)}` +
      `&action=EstadoDocumento` +
      `&date=${encodeURIComponent(moment(new Date()).format("YYYYMMDDHHmmss"))}`;

    const response = await fetch(urlFetch);
    if (!response.ok) {
      console.error("Error consultando estado HKA:", response.status);
      return false;
    }
    const result = await response.json();
    if (result.codigo === "200") {
      const actualizado = await put_fac_factura_sts({ fac_id, fac_sts: 1, fac_cufe: result.cufe, fac_resultado: result.resultado, fac_mensaje: result.mensaje, fac_tipodocumento, fac_hka_validado: validacionHKA ? 1 : 0 });
      if (actualizado === false) {
        console.error("HKA confirmó la factura, pero no se pudo actualizar fac_factura");
        return false;
      }
      return true;
    }
    if (validacionHKA && result.codigo === "102") {
      const actualizado = await put_fac_factura_sts({ fac_id, fac_sts: 0, fac_cufe: "", fac_resultado: result.resultado, fac_mensaje: result.mensaje, fac_tipodocumento, fac_hka_validado: 2 });
      if (actualizado === false) {
        return false;
      }
      return false;
    }
    return false;
  } catch (error) {
    return false;
  }
}
export async function consultar_ruc({ ruc }) {
  var urlFetch = urlFacturaElectronica + `consultarRucDv.php?ruc=${encodeURIComponent(ruc)}&action=GetRucDV&date=${encodeURIComponent(moment(new Date()).format("YYYYMMDDHHmmss"))}`;
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return JSON.parse(JSON.stringify(data));
    });
  return response;
}
export async function folios_restantes() {
  var urlFetch = urlFacturaElectronica + "consultarRucDv.php?&action=foliosRestantes&/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return JSON.parse(JSON.stringify(data));
    });
  return response;
}
export async function open_cashDrawer() {
  var urlFetch = "http://localhost:8080/sys_mbo/tax_sysm/consultarRucDv.php?&action=open_cashDrawer&/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch);
  return response;
}

export async function get_cajas() {
  var urlFetch = url + "SettingController/get_cajas/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cli_cliente_restaurant() {
  var urlFetch = url + "ClienteController/get_cli_cliente_restaurant/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cli_cliente(usr_sucursal) {
  var urlFetch = url + "ClienteController/get_cli_cliente/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function put_cli_cliente_sts(data) {
  const response = await fetch(url + "ClienteController/put_cli_cliente_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_res_restaurante_inactivo(data) {
  const response = await fetch(url + "RestauranteController/put_res_restaurante_inactivo", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_res_restaurante_sts(data) {
  const response = await fetch(url + "RestauranteController/put_res_restaurante_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_res_restaurante(data) {
  const response = await fetch(url + "RestauranteController/put_res_restaurante", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_cli_cliente(data) {
  const response = await fetch(url + "ClienteController/put_cli_cliente", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_pro_proveedor(data) {
  const response = await fetch(url + "ProveedorController/post_pro_proveedor", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function get_pro_proveedor() {
  var urlFetch = url + "ProveedorController/get_pro_proveedor/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function put_pro_proveedor_sts(data) {
  const response = await fetch(url + "ProveedorController/put_pro_proveedor_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_pro_proveedor(data) {
  const response = await fetch(url + "ProveedorController/put_pro_proveedor", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_cat_categoria(data) {
  const response = await fetch(url + "CategoriaController/post_cat_categoria", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_co_comanda() {
  var urlFetch = url + "CategoriaController/get_co_comanda/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cat_categoria() {
  var urlFetch = url + "CategoriaController/get_cat_categoria/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_cat_categoria(data) {
  const response = await fetch(url + "CategoriaController/put_cat_categoria", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_cat_categoria_sts(data) {
  const response = await fetch(url + "CategoriaController/put_cat_categoria_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_des_descuento(data) {
  const response = await fetch(url + "DescuentoController/post_des_descuento", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_gr_garantia(data) {
  const response = await fetch(url + "GarantiaController/post_gr_garantia", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_mar_marca(data) {
  const response = await fetch(url + "MarcaController/post_mar_marca", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_mar_marca() {
  var urlFetch = url + "MarcaController/get_mar_marca/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_des_descuento() {
  var urlFetch = url + "DescuentoController/get_des_descuento/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_gr_garantia() {
  var urlFetch = url + "GarantiaController/get_gr_garantia/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_mar_marca(data) {
  const response = await fetch(url + "MarcaController/put_mar_marca", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_des_descuento(data) {
  const response = await fetch(url + "DescuentoController/put_des_descuento", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_des_descuento_sts(data) {
  const response = await fetch(url + "DescuentoController/put_des_descuento_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_gr_garantia(data) {
  const response = await fetch(url + "GarantiaController/put_gr_garantia", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_gr_garantia_sts(data) {
  const response = await fetch(url + "GarantiaController/put_gr_garantia_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_mar_marca_sts(data) {
  const response = await fetch(url + "MarcaController/put_mar_marca_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_res_restaurante(data) {
  const response = await fetch(url + "RestauranteController/post_res_restaurante", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_ord_ordenes(ord_mesa) {
  var urlFetch = url + "OrdenController/get_ord_ordenes/" + ord_mesa + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_ord_ordenes_mesas() {
  var urlFetch = url + "OrdenController/get_ord_ordenes_mesas/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_res_restaurante() {
  var urlFetch = url + "RestauranteController/get_res_restaurante/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_usr_usuario(data) {
  const response = await fetch(url + "UsuarioController/post_usr_usuario", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_ord_cocina() {
  var urlFetch = url + "OrdenController/get_ord_cocina/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_usr_usuario() {
  var urlFetch = url + "UsuarioController/get_usr_usuario/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_orden_detalle(data) {
  const response = await fetch(url + "OrdenController/put_orden_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_delete_orden_detalle(data) {
  const response = await fetch(url + "OrdenController/put_delete_orden_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_delete_orden_by_ord(data) {
  const response = await fetch(url + "OrdenController/put_delete_orden_by_ord", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_check_orden(data) {
  const response = await fetch(url + "OrdenController/put_check_orden", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_ord_nombre_mesa({ data }) {
  const response = await fetch(url + "OrdenController/put_ord_nombre_mesa", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_para_llevar({ data }) {
  const response = await fetch(url + "OrdenController/put_para_llevar", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_comanda({ data }) {
  const response = await fetch(url + "OrdenController/put_comanda", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_comanda_info({ data }) {
  const response = await fetch(url + "OrdenController/put_comanda_info", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_sts_ordenes(data) {
  const response = await fetch(url + "OrdenController/put_sts_ordenes", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_usr_usuario(data) {
  const response = await fetch(url + "UsuarioController/put_usr_usuario", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_usr_usuario_sts(data) {
  const response = await fetch(url + "UsuarioController/put_usr_usuario_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_art_articulo(data) {
  const response = await fetch(url + "ArticuloController/post_art_articulo", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_art_articulo({ usr_sucursal }) {
  var urlFetch = url + "ArticuloController/get_art_articulo/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_img_publicidad() {
  var urlFetch = url + "ArticuloController/get_img_publicidad/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_img_publicidad(data) {
  const response = await fetch(url + "ArticuloController/post_img_publicidad", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_img_publicidad(data) {
  const response = await fetch(url + "ArticuloController/put_img_publicidad", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_art_articulo(data) {
  const response = await fetch(url + "ArticuloController/put_art_articulo", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_art_articulo_sts(data) {
  const response = await fetch(url + "ArticuloController/put_art_articulo_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_delete_img(body) {
  const response = await fetch(url + "ArticuloController/put_delete_img", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_delete_img_gastos(body) {
  const response = await fetch(url + "GastosController/put_delete_img", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_delete_img_publicidad(body) {
  const response = await fetch(url + "ArticuloController/put_delete_img_publicidad", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_artb_sts(body) {
  const response = await fetch(url + "ArticuloController/put_artb_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_apartado() {
  var urlFetch = url + "ApartadoController/get_apartado/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_inventario(usr_sucursal) {
  var urlFetch = url + "CompraController/get_inventario/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_cot_cotizacion_sts(data) {
  const response = await fetch(url + "CotizacionController/put_cot_cotizacion_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_dc_compra_sts(data) {
  const response = await fetch(url + "CompraController/put_dc_compra_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_fac_factura_sts({ fac_id, fac_sts, fac_cufe, fac_resultado, fac_mensaje, fac_tipodocumento, fac_hka_validado }) {
  const dataUpdate = {
    fac_id,
    fac_sts,
    fac_cufe,
    fac_resultado,
    fac_mensaje,
    fac_tipodocumento,
  };

  if (fac_hka_validado !== undefined) {
    dataUpdate.fac_hka_validado = fac_hka_validado;
  }
  // const body = {fac_id,fac_sts, fac_cufe, fac_resultado, fac_mensaje, fac_tipodocumento};
  try {
    const response = await fetch(url + "FacturaController/put_fac_factura_sts", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataUpdate),
    });

    if (!response.ok) {
      return false;
    }
    return await response.json();
  } catch (e) {
    return false;
  }
}

export async function put_ap_apartado_sts(data) {
  const response = await fetch(url + "ApartadoController/put_ap_apartado_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function get_articulo_detail(art_upc) {
  var urlFetch = url + "CompraController/get_articulo_detail/" + art_upc + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_articulo_by_code(art_upc, usr_sucursal) {
  var urlFetch = url + "CompraController/get_articulo_by_code/" + art_upc + "/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_dc_compra(data) {
  const response = await fetch(url + "CompraController/post_dc_compra", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function post_ap_apartado(data) {
  const response = await fetch(url + "ApartadoController/post_ap_apartado", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function post_cot_cotizacion(data) {
  const response = await fetch(url + "CotizacionController/post_cot_cotizacion", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_artb_bodega(data) {
  const response = await fetch(url + "ArticuloController/post_artb_bodega", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_compra_detalle(dc_identificador) {
  var urlFetch = url + "CompraController/get_compra_detalle/" + dc_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_apartado_detalle(dc_identificador) {
  var urlFetch = url + "ApartadoController/get_apartado_detalle/" + dc_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_all_cotizacion({ usr_sucursal }) {
  var urlFetch = url + "CotizacionController/get_all_cotizacion/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cotd_cotizacion_detail(cotd_identificador) {
  var urlFetch = url + "CotizacionController/get_cotd_cotizacion_detail/" + cotd_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_dc_compra(data) {
  const response = await fetch(url + "CompraController/put_dc_compra", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function delete_ap_apartado_detalle(data) {
  const response = await fetch(url + "ApartadoController/delete_ap_apartado_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function delete_dc_compra_detalle(data) {
  const response = await fetch(url + "CompraController/delete_dc_compra_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_cotd_cotizacion_detalle_row(data) {
  const response = await fetch(url + "CotizacionController/put_cotd_cotizacion_detail_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_apd_apartado_detalle_row(data) {
  const response = await fetch(url + "ApartadoController/put_apd_apartado_detalle_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_apd_apartado_encabezado(data) {
  const response = await fetch(url + "ApartadoController/put_apd_apartado_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_dcd_compra_detalle_row(data) {
  const response = await fetch(url + "CompraController/put_dcd_compra_detalle_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_ap_apartado_detalle_row(data) {
  const response = await fetch(url + "ApartadoController/post_ap_apartado_detalle_row,", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_dc_compra_detalle_row(data) {
  const response = await fetch(url + "CompraController/post_dc_compra_detalle_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_dcd_compra_encabezado(data) {
  const response = await fetch(url + "CompraController/put_dcd_compra_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function processInventario(data) {
  const response = await fetch(url + "CompraController/processInventario", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_fcd_factura_detalle_row(data) {
  const response = await fetch(url + "FacturaController/put_fcd_factura_detalle_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_factura_detalle(fac_identificador) {
  var urlFetch = url + "FacturaController/get_factura_detalle/" + fac_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_fac_factura_encabezado(data) {
  const response = await fetch(url + "FacturaController/put_fac_factura_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_facturas_hka_pendientes({ usr_sucursal }) {
  var urlFetch = url + "FacturaController/get_facturas_hka_pendientes/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_factura(fac_id) {
  var urlFetch = url + "FacturaController/get_factura/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_fac_factura_detalle_row(data) {
  const response = await fetch(url + "FacturaController/post_fac_factura_detalle_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function delete_fcd_factura_detalle(data) {
  const response = await fetch(url + "FacturaController/delete_fcd_factura_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_ord_orden(data) {
  const response = await fetch(url + "OrdenController/post_ord_orden", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_fac_factura(data) {
  try {
    const response = await fetch(url + "FacturaController/post_fac_factura", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      console.error("Error HTTP post_fac_factura:", response.status, response.statusText);
      return false;
    }
    const result = await response.json();
    if (result === false || result === null || result === undefined) {
      return false;
    }
    return result;
  } catch (e) {
    console.error("Error post_fac_factura:", e);
    return false;
  }
}
export async function get_frm_pago() {
  var urlFetch = url + "FormaPagoController/get_frm_pago/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_itbms() {
  var urlFetch = url + "SettingController/get_itbms/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_AnulacionElectronica(data, usr_prints) {
  const alertError = ({ props }) =>
    toast.error(
      <>
        <span>{"Código : " + props.codigo}</span>
        <br />
        <span>{"Resultado : " + props.resultado}</span>
        <br />
        <span>{"Mensaje : " + props.mensaje}</span>{" "}
      </>
    );
  const alertSuccess = ({ props }) =>
    toast.success(
      <>
        <span>{"Código : " + props.codigo}</span>
        <br />
        <span>{"Resultado : " + props.resultado}</span>
        <br />
        <span>{"Mensaje : " + props.mensaje}</span>
      </>
    );

  return new Promise((resolve, reject) => {
    $.ajax({
      url: data.print_type === "2" || data.print_type === "3" ? IP_FE_LOCAL + "/sys_mbo/tax_sysm/fac.php" : IP + "/sys_mbo/tax_sysm/fac.php",
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(data),
      type: "POST",
      success: async function (response) {
        try {
          const result = typeof response === "string" ? JSON.parse(response) : response;
          if (data.print_type !== "3") {
            if (result.codigo === "200") {
              const anulada = await postAnular(data);
              if (anulada === false) {
                console.error("HKA autorizó la anulación, pero no se pudo actualizar la factura localmente");
                toast.error("HKA autorizó la anulación, pero ocurrió un error actualizando la factura local.");
                resolve("LOCAL_ERROR");
                return;
              }
              // 2. REGRESAR INVENTARIO Y SERIES
              const regreso = await regreso_inventario({ formFactura: { fac_identificador: data.props_anulacion.fac_identificador, fac_sucursal: data.usr_sucursal, fac_tipodocumento: "01" } });
              if (regreso === false) {
                console.error("La factura fue anulada, pero no se pudo regresar el inventario");
                toast.error("La factura fue anulada, pero ocurrió un error regresando el inventario.");
                resolve("LOCAL_ERROR");
                return;
              }
              if (data.print_type === "1") {
                window.open(IP + "/sys_mbo/tax_sysm/pdf/" + data.fac_docn + ".pdf?" + moment(new Date()).format("YYYYMMDDHHmmss"));
                setTimeout(() => {
                  window.innerWidth <= 620 && descargar_factura_pdf(data.fac_docn);
                }, 1500);
              }
              alertSuccess({ props: result });
              resolve(result.codigo);
              return;
            }

            postError({ result, data, doc_n: data.fac_docn, com_suc: data.dataCompany.com_nombre });
            alertError({ props: result });
            resolve(result.codigo);
            return;
          }

          const anulada = await postAnular(data);
          if (anulada === false) {
            toast.error("No se pudo marcar el recibo como anulado.");
            resolve("LOCAL_ERROR");
            return;
          }

          const regreso = await regreso_inventario({
            formFactura: {
              fac_identificador: data.props_anulacion.fac_identificador,
              fac_sucursal: data.usr_sucursal,
              fac_tipodocumento: "01",
            },
          });

          if (regreso === false) {
            toast.error("El recibo fue anulado, pero no se pudo regresar el inventario.");
            resolve("LOCAL_ERROR");
            return;
          }
          resolve("200");
        } catch (error) {
          reject(error);
        }
      },
      error: function (err) {
        const resultError = {
          codigo: err.status || "CONEXION",
          resultado: "Error de comunicación",
          mensaje: err.statusText || "No se pudo obtener respuesta del servidor",
        };
        postError({
          result: resultError,
          data,
          doc_n: data.fac_docn,
          com_suc: data.dataCompany.com_nombre,
        });
        alertError({
          props: resultError,
        });
        reject(err);
      },
    });
  });
}

export async function post_facturaElectronica({ data, formRestaurante, isGuardarFactura, data_fac_factura }) {
  const alertError = ({ props }) =>
    toast.error(
      <>
        <span>{"Código : " + props.codigo}</span>
        <br />
        <span>{"Resultado : " + props.resultado}</span>
        <br />
        <span>{"Mensaje : " + props.mensaje}</span>
      </>
    );

  const alertSuccess = ({ props }) =>
    toast.success(
      <>
        <span>{"Código : " + props.codigo}</span>
        <br />
        <span>{"Resultado : " + props.resultado}</span>
        <br />
        <span>{"Mensaje : " + props.mensaje}</span>
      </>
    );

  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${data.print_type === "2" || data.print_type === "3" ? IP_FE_LOCAL : IP}/sys_mbo/tax_sysm/fac.php`,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(data),
      type: "POST",
      success: async function (response) {
        try {
          const result = JSON.parse(response);
          if (data?.facCopia === true) {
            // COPIA / REIMPRESIÓN DE FACTURA
            if (result.codigo === "200") {
              if (data.print_type === "1") {
                window.open(`${IP}/sys_mbo/tax_sysm/pdf/${data.fac_docn}.pdf?` + moment(new Date()).format("YYYYMMDDHHmmss"));
                setTimeout(() => {
                  window.innerWidth <= 820 && descargar_factura_pdf(data.fac_docn);
                }, 1000);
              }
              alertSuccess({ props: result });
            } else {
              postError({ result, data, doc_n: data.fac_docn, com_suc: data.dataCompany.com_nombre });
              alertError({ props: result });
            }
            resolve(result.codigo);
            return;
          }
          if (data.print_type !== "3") {
            // 1,2 ES FISCAL
            if (result.codigo === "200") {
              setTimeout(() => {
                consultar_estadoDocumento({
                  numeroDocumentoFiscal: data.fac_docn,
                  codigoSucursalEmisor: data.codigoSucursalEmisor,
                  fac_id: data.fac_id,
                  fac_tipodocumento: data.tipoDocumento,
                  punto_facturacion: data.punto_facturacion,
                });
              }, 2000);
              if (data.print_type === "1") {
                window.open(`${IP}/sys_mbo/tax_sysm/pdf/${data.fac_docn}.pdf?` + moment(new Date()).format("YYYYMMDDHHmmss"));
                setTimeout(() => {
                  window.innerWidth <= 820 && descargar_factura_pdf(data.fac_docn);
                }, 1000);
              }

              if (isGuardarFactura && formRestaurante?.current_ord_identificador?.length > 0) {
                //true es cuando GUARDAR_FACTURA
                await put_facturado_orden({ ordd_identificador: formRestaurante.current_ord_identificador });
              }

              alertSuccess({ props: result });
              if (data_fac_factura?.isNc && data?.facCopia !== true) {
                await regreso_inventario(data_fac_factura);
              }
            } else {
              // GUARDAR RESPUESTA DE ERROR DE HKA EN LA FACTURA
              await put_fac_factura_sts({ fac_id: data.fac_id, fac_sts: 0, fac_cufe: "", fac_resultado: result.resultado ?? "", fac_mensaje: result.mensaje ?? "", fac_tipodocumento: data.tipoDocumento });

              if (isGuardarFactura && !data_fac_factura?.isNc) {
                const regreso = await regreso_inventario(data_fac_factura);
                if (regreso === false) {
                  console.error("No se pudo regresar el inventario");
                }
              }
              postError({ result, data, doc_n: data.fac_docn, com_suc: data.dataCompany.com_nombre });
              alertError({ props: result });
            }
          } else {
            //RECIBO NO FISCAL
            if (isGuardarFactura) {
              const sts = await put_fac_factura_sts({ fac_id: data.fac_id, fac_cufe: "RECIBO NO FISCAL", fac_resultado: "procesado", fac_sts: "1", fac_mensaje: "", fac_tipodocumento: data.tipoDocumento });
              if (sts === false) {
                console.error("No se pudo actualizar el estado del recibo no fiscal");
              }
              if (formRestaurante?.current_ord_identificador?.length > 0) {
                await put_facturado_orden({ ordd_identificador: formRestaurante.current_ord_identificador });
              }
            }
          }
          resolve(result.codigo);
        } catch (error) {
          reject(error);
        }
      },
      error: async function (err) {
        if (data?.facCopia !== true) {
          await put_fac_factura_sts({ fac_id: data.fac_id, fac_sts: 0, fac_cufe: "", fac_resultado: "Error de comunicación", fac_mensaje: err.statusText || "No se pudo obtener respuesta del servidor", fac_tipodocumento: data.tipoDocumento });
        }
        const resultError = {
          codigo: err.status || "CONEXION",
          resultado: "Error de comunicación",
          mensaje: err.statusText || "No se pudo obtener respuesta del servidor",
        };

        postError({ result: resultError, data, doc_n: data.fac_docn, com_suc: data.dataCompany.com_nombre });
        alertError({ props: resultError });
        reject(err);
      },
    });
  });
}
export async function get_artb_bodega_by_articulo(artb_articulo) {
  var urlFetch = url + "ArticuloController/get_artb_bodega_by_articulo/" + artb_articulo + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_list_items_restaurante(usr_sucursal) {
  var urlFetch = url + "ArticuloController/get_list_items_restaurante/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_list_items(usr_sucursal) {
  var urlFetch = url + "ArticuloController/get_list_items/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_list_items_bodega() {
  var urlFetch = url + "ArticuloController/get_list_items_bodega/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_cotizacion() {
  var urlFetch = url + "CotizacionController/get_cotizacion/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function post_cotd_cotizacion_detalle_row(data) {
  const response = await fetch(url + "CotizacionController/post_cotd_cotizacion_detalle_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function postAnular(data) {
  const response = await fetch(url + "FacturaController/postAnular", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_report_x({ startDate, endDate, fac_caja, fac_vendedor, sucursal }) {
  var urlFetch = url + "ReportsController/get_report_x/" + startDate + "/" + endDate + "/" + fac_caja + "/" + fac_vendedor + "/" + sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_ventas_global(fac_fecha) {
  var urlFetch = url + "ReportsController/get_cotizacion/" + fac_fecha + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_list_fac_imprimir({ fac_sucursal }) {
  var urlFetch = url + "FacturaController/get_list_fac_imprimir/" + fac_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_list_itemsFactura(fcd_identificador) {
  var urlFetch = url + "ArticuloController/get_list_itemsFactura/" + fcd_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_list_itemsFactura_detail(fcd_identificador) {
  var urlFetch = url + "ArticuloController/get_list_itemsFactura_detail/" + fcd_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_frm_pago_imprimir_fac(fcd_identificador) {
  var urlFetch = url + "FormaPagoController/get_frm_pago_imprimir_fac/" + fcd_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_list_anulacion({ fac_sucursal }) {
  var urlFetch = url + "FacturaController/get_list_anulacion/" + fac_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_existencia_inventario() {
  var urlFetch = url + "ReportsController/get_report_existencia_inventario/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_report_x_global(startDate, endDate, suc_sucursal) {
  var urlFetch = url + "ReportsController/get_report_x_global/" + startDate + "/" + endDate + "/" + suc_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_venta(startDate, endDate, suc_sucursal) {
  var urlFetch = url + "ReportsController/get_report_ventas_global/" + startDate + "/" + endDate + "/" + suc_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

// export  async function print_report_x(data) {
//   $.ajax({
//     url: 'http://localhost:8080/sys_mbo/tax_sysm/recibo_reporte_x.php',
//     data:JSON.stringify(data),
//     type: 'POST',
//     success: function(response){
//         if(response===1){
//         }else{
//         }
//       }
// });
//   return true;
// }

export async function postDisplay() {
  const resolucion = {
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio,
    userAgent: navigator.userAgent,
    isWindows: navigator.userAgent.includes("Windows"),
    isChrome: navigator.userAgent.includes("Chrome"),
    isMobile: /Android|iPhone/i.test(navigator.userAgent),
  };
  const response = await fetch("https://mtc.mtechnologypanama.com/sys_mbo/ErrorController/postDisplay", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(resolucion),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function postError(data) {
  const response = await fetch("https://mtc.mtechnologypanama.com/sys_mbo/ErrorController/postError", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function delete_movimiento_detalle(data) {
  const response = await fetch(url + "MovimientoController/delete_movimiento_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function regreso_inventario(data) {
  try {
    const response = await fetch(url + "FacturaController/regreso_inventario", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      console.error("Error HTTP regreso_inventario:", response.status, response.statusText);
      return false;
    }

    const result = await response.json();

    if (result === false || result === null || result === undefined) {
      return false;
    }

    return result;
  } catch (e) {
    console.error("Error regreso_inventario:", e);
    return false;
  }
}
export async function delete_red_recuento_detalle(data) {
  const response = await fetch(url + "RecuentoController/delete_red_recuento_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_re_recuento_sts(data) {
  const response = await fetch(url + "RecuentoController/put_re_recuento_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_mov_movimiento_sts(data) {
  const response = await fetch(url + "MovimientoController/put_mov_movimiento_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_mov_movimiento_detalle_row(data) {
  const response = await fetch(url + "MovimientoController/put_mov_movimiento_detalle_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_red_recuento_detalle_row(data) {
  const response = await fetch(url + "RecuentoController/put_red_recuento_detalle_row", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_mov_movimiento_encabezado(data) {
  const response = await fetch(url + "MovimientoController/put_mov_movimiento_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_re_recuento_encabezado(data) {
  const response = await fetch(url + "RecuentoController/put_re_recuento_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function procesar_movimiento(data) {
  const response = await fetch(url + "MovimientoController/procesar_movimiento", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function procesar_recuento(data) {
  const response = await fetch(url + "RecuentoController/procesar_recuento", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_movd_movimiento_detalle(data) {
  const response = await fetch(url + "MovimientoController/put_movd_movimiento_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_movd_movimiento_detalle(data) {
  const response = await fetch(url + "MovimientoController/post_movd_movimiento_detalle_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_red_recuento_detalle(data) {
  const response = await fetch(url + "RecuentoController/post_red_recuento_detalle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_mov_movimiento(data) {
  const response = await fetch(url + "MovimientoController/post_mov_movimiento", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_re_recuento(data) {
  const response = await fetch(url + "RecuentoController/post_re_recuento", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_recuento(usr_sucursal) {
  var urlFetch = url + "RecuentoController/get_recuento/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_movimiento() {
  var urlFetch = url + "MovimientoController/get_movimiento/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_movimiento_detalle(mov_identificador) {
  var urlFetch = url + "MovimientoController/get_movimiento_detalle/" + mov_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_recuento_detalle(re_identificador, usr_sucursal) {
  var urlFetch = url + "RecuentoController/get_recuento_detalle/" + re_identificador + "/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_trazabilidad(usr_sucursal) {
  var urlFetch = url + "CompraController/get_trazabilidad/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_trazabilidad_detallado(art_id, usr_sucursal) {
  var urlFetch = url + "CompraController/get_trazabilidad_detallado/" + art_id + "/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_ord_ordenes_ord({ ordd_identificador }) {
  var urlFetch = url + "OrdenController/get_ord_ordenes_ord/" + ordd_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_ord_ordenes_list({ isRestaurant, usr_sucursal }) {
  var urlFetch = url + "OrdenController/get_ord_ordenes_list/" + isRestaurant + "/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cot_cotizacion_list({ usr_sucursal }) {
  var urlFetch = url + "CotizacionController/get_cot_cotizacion_list/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cot_cotizacion_fac({ cot_identificador }) {
  var urlFetch = url + "CotizacionController/get_cot_cotizacion_fac/" + cot_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_cot_cotizacion_encabezado(data) {
  const response = await fetch(url + "CotizacionController/put_cot_cotizacion_encabezado", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_entregado_orden(data) {
  const response = await fetch(url + "OrdenController/put_entregado_orden", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_ordd_detalle(data) {
  const response = await fetch(url + "OrdenController/put_ordd_detalle", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function post_ordd_detalle(data) {
  const response = await fetch(url + "OrdenController/post_ordd_detalle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_crp_credito_pago(data) {
  const response = await fetch(url + "CreditoController/post_crp_credito_pago", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_cotd_cotizacion_detail_row(data) {
  const response = await fetch(url + "CotizacionController/post_cotd_cotizacion_detail_row", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function delete_cotd_cotizacion_detail(data) {
  const response = await fetch(url + "CotizacionController/delete_cotd_cotizacion_detail", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_report_ventas_mensuales({ startDate, endDate, suc_sucursal }) {
  var urlFetch = url + "ReportsController/get_report_ventas_mensuales/" + startDate + "/" + endDate + "/" + suc_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function get_report_productos_vendidos({ startDate, endDate, sucursal }) {
  var urlFetch = url + "ReportsController/get_report_productos_vendidos/" + startDate + "/" + endDate + "/" + sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_productos_masvendidos({ startDate, endDate }) {
  var urlFetch = url + "ReportsController/get_report_productos_masvendidos/" + startDate + "/" + endDate + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_utilidad_margen({ startDate, endDate }) {
  var urlFetch = url + "ReportsController/get_report_utilidad_margen/" + startDate + "/" + endDate + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cr_credito({ usr_sucursal }) {
  var urlFetch = url + "CreditoController/get_cr_credito/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cr_credito_detalle(crd_cliente) {
  var urlFetch = url + "CreditoController/get_cr_credito_detalle/" + crd_cliente + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_re_retencion() {
  var urlFetch = url + "SettingController/get_re_retencion/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_cr_credito_detalle_byIdentificador(crd_fac_identificador) {
  var urlFetch = url + "CreditoController/get_cr_credito_detalle_byIdentificador/" + crd_fac_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_report_creditos({ startDate, endDate, suc_sucursal }) {
  var urlFetch = url + "ReportsController/get_report_creditos/" + startDate + "/" + endDate + "/" + suc_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_crp_credito_pago(crd_fac_identificador) {
  var urlFetch = url + "CreditoController/get_crp_credito_pago/" + crd_fac_identificador + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}
export async function put_ord_number(data) {
  const response = await fetch(url + "OrdenController/put_ord_number", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function put_facturado_orden(data) {
  const response = await fetch(url + "OrdenController/put_facturado_orden", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function delete_crp_credito_pago(data) {
  const response = await fetch(url + "CreditoController/put_crp_credito_pago_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function print_recibo_pago(data) {
  $.ajax({
    url: "http://localhost:8080/sys_mbo/tax_sysm/recibo_pago_credito.php",
    data: JSON.stringify(data),
    type: "POST",
    success: function (response) {
      if (response === 1) {
      } else {
        console.log(response);
      }
    },
  });
  return true;
}

export async function print_recibo_pagoCopia(data) {
  $.ajax({
    url: "http://localhost:8080/sys_mbo/tax_sysm/recibo_pago_creditoCopia.php",
    data: JSON.stringify(data),
    type: "POST",
    success: function (response) {
      if (response === 1) {
      } else {
        console.log(response);
      }
    },
  });
  return true;
}

export async function post_gas_gastos(data) {
  const response = await fetch(url + "GastosController/post_gas_gastos", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
export async function get_gas_gastos_range({ date1, date2, usr_sucursal }) {
  var urlFetch = url + "GastosController/get_gas_gastos_range/" + date1 + "/" + date2 + "/" + usr_sucursal + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function get_gas_gastos({ date }) {
  var urlFetch = url + "GastosController/get_gas_gastos/" + date + "/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_gas_gastos(data) {
  const response = await fetch(url + "GastosController/put_gas_gastos", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_gas_gastos_sts(data) {
  const response = await fetch(url + "GastosController/put_gas_gastos_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function get_tipo_gastos() {
  var urlFetch = url + "GastosController/get_tipo_gastos/" + moment(new Date()).format("YYYYMMDDHHmmss");
  const response = fetch(urlFetch)
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
  return response;
}

export async function put_tipo_gastos_sts(data) {
  const response = await fetch(url + "GastosController/put_tipo_gastos_sts", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function put_tipo_gastos(data) {
  const response = await fetch(url + "GastosController/put_tipo_gastos", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}

export async function post_tipo_gastos(data) {
  const response = await fetch(url + "GastosController/post_tipo_gastos", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch(function (e) {
      console.log(e);
    });
  return response;
}
